const auditStatus = Object.freeze({
  init: -1,
  submitted: 0,
  pending: 1,
  completed: 2,
  rejected: 3,
  reaudit: 4,
})

export default auditStatus

export const getAuditStatusByNumber = number => {
  switch (number) {
    case 0:
      return auditStatus.submitted
    case 1:
      return auditStatus.pending
    case 2:
      return auditStatus.completed
    case 3:
      return auditStatus.rejected
    case 4:
      return auditStatus.reaudit
    default:
      return auditStatus.init
  }
}

export const getAuditStatusByString = statusString => {
  switch (statusString) {
    case 'Submitted':
      return auditStatus.submitted
    case 'Pending':
      return auditStatus.pending
    case 'Completed':
      return auditStatus.completed
    case 'Rejected':
      return auditStatus.rejected
    case 'Re-Audit':
      return auditStatus.reaudit
    default:
      return auditStatus.init
  }
}
